import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToolboxItem } from '../../types';
import { TOOLBOX_ITEMS } from '../../constants';

interface ToolboxState {
  items: ToolboxItem[];
}

const initialState: ToolboxState = {
  items: [...TOOLBOX_ITEMS],
};

const toolboxSlice = createSlice({
  name: 'toolbox',
  initialState,
  reducers: {
    addItem: (state, action: PayloadAction<ToolboxItem>) => {
      // Avoid duplicate IDs
      if (!state.items.find(item => item.id === action.payload.id)) {
        state.items.push(action.payload);
      }
    },
    removeItem: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
    updateItem: (state, action: PayloadAction<ToolboxItem>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    resetToolbox: (state) => {
      state.items = [...TOOLBOX_ITEMS];
    },
    importToolbox: (state, action: PayloadAction<ToolboxItem[]>) => {
      state.items = action.payload;
    }
  },
});

export const { addItem, removeItem, updateItem, resetToolbox, importToolbox } = toolboxSlice.actions;
export default toolboxSlice.reducer;
